import { ChartLine as LineChartIcon } from "lucide-react";
import {
  RunChartParamsSchema,
  defaultRunChartParams,
  type RunChartParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { RunChartWidget } from "./Component.js";

export const runChartDef: WidgetDef<RunChartParams> = {
  kind: "runChart",
  label: "Run Chart",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 352, h: 324 },
  defaultParams: defaultRunChartParams,
  Component: RunChartWidget,
  storage: "sql",
  schema: RunChartParamsSchema,
  accent: "cyan",
  icon: LineChartIcon,
  subtitle: "KPI trend over time",
  renderTitle: (data) => data.title?.trim() || "Run Chart",
  renderSubtitle: (data) =>
    `Trend over time${data.unit?.trim() ? ` (${data.unit.trim()})` : ""}`,
  defaultRoster: true,
  category: "multi",
  layout: { col: 0, row: 1, width: 352, height: 300 },
  expandable: true,
  renderFooter: (data) => ({
    left:
      data.points.length > 0
        ? `${data.points.length} data points`
        : "No data yet",
    right:
      data.target != null
        ? `Target ${data.target}${data.unit ? ` ${data.unit}` : ""}`
        : "",
  }),
};

registerWidget(runChartDef);
